import store from '@/store/index'

// let userId = store.state.common.sessionInfo.userId;
// let sessionStr = store.state.common.sessionInfo.sessionStr;
let token = store.state.common.sessionInfo.token;

// let i = {
//     'session': {
//         'fid': 'session',
//         'bid': {
//             'login': 'login',
//             'logout': 'logout',
//             'authorizeSession': 'authorize',
//             'validCapt': 'validCapt',
//             'captcha': 'captcha',
//             'authorize': 'authorize',
//             'updatePassword': 'password',
//         }
//     },
// }

var userURL = "/api-admin";
var projectURL = "/api-project/webProject";
var investmentURL = "/api-project/webInvestment";
var collectionURL = "/api-project/collection";
var cmsURL = "/api-cms";
export default {
    //因为页面有跳转三方界面，不能直定义变量存储，统一放到sessionStorage中
    param_hotNews: {
        url: cmsURL + "/content/hotnewsGWtList",
        data:{

        }
    },
    param_addViews: {
        url: cmsURL + "/content/addViews",
        data:{
            id : ''
        }
    },

    param_lastNews:{
        url: cmsURL + "/content/lastNews",
        data:{
            id : '',
            channelId : ''
        }
    },
    param_nextNews:{
        url: cmsURL + "/content/nextNews",
        data:{
            id : '',
            channelId : ''
        }
    },
    param_registerVerifyCode: {
        url: userURL + "/registerVerifyCode",
        data: {
            mobile: ''
        }
    },
    param_rePasswordverifyCode: {
        url: userURL + "/rePasswordVerifyCode",
        data: {
            mobile: ''
        }
    },
    // 注册
    param_register: {
        url: userURL + "/register",
        data: {
            moblie: '',
            pwd: ''
        }
    },
    //找回密码
    param_rePassword: {
        url: userURL + "/rePassword",
        data: {
            moblie: '',
            pwd: ''
        }
    },
    // 登录
    param_login: {
        url: userURL + "/loginByMobile",
        data: {
            username: '',
            moblie: '',
            password: '',
            captchaId: '',
            code: '',
            terminalType: 'ExchangeConsole'
        }
    },
    // 设置用户类型
    param_setUserType: {
        url: userURL + "/user/setUserType",
        data: {
            type: ''
        }
    },
    param_allNews: {
        url: cmsURL + "/content/newsGWtList",
        data:{

        }
    },
    

    // 退出
    param_logout: {
        url: userURL + "/logout",
        pname: "logOut",
        param: {
            "token": token
        }
    },
    //获取当前用户信息
    param_getUser: {
        url: userURL + '/user/currentUser',
        param: {
            "token": token
        }
    },
   
    //查询公告信息
    // param_getArticle: {
    //     url: "/getArticle",
    //     pname: "getArticle",
    //     param: {

    //         "token": token
    //     }
    // },
    // //查询项目信息
    // param_projectList: {
    //     url: projectURL + "/projectList",
    //     pname: "project",
    //     param: {
    //         /* "projectName":projectName,
    //         "type":type,
    //         "status":status,
    //         "province":province,
    //         "money":money,
    //         "updTimeDesc":updTimeDesc,
    //         "moneyDesc":moneyDesc,
    //         "limit":limit,
    //         "page":page */

    //     }
    // },

    // //项目信息详情
    // param_projectDetail: {
    //     url: projectURL + "/getProjectInfo",
    //     pname: "getProjectInfo",
    //     data: {
    //         "projectName": '',
    //         "projectId": ''
    //     }
    // },
    // //查询投资需求
    // param_investmentList: {
    //     url: investmentURL + "/investmentList",
    //     pname: "investment",
    //     param: {
    //         /* 
    //          "title":title
    //         "status":status,
    //         "limit":limit,
    //         "page":page */

    //     }
    // },
    // param_investmentDetail: {
    //     url: investmentURL + "/getInvestment",
    //     pname: "investmentDetail",
    //     data: {}
    // },
    // param_addCollection: {
    //     url: collectionURL + "/addCollection",
    //     data: {
    //         "token": token
    //     }
    // },
    //查询公告列表
    // param_contentList: {
    //     url: cmsURL + "/contentList",
    //     pname: "content",
    //     param: {}
    // },
    // param_contentDetail: {
    //     url: cmsURL + "/getContent",
    //     pname: "contentDetail",
    //     param: {}
    // },
 
}


// WEBPACK FOOTER //
// ./src/assets/js/trans/protocol.js